import { sortBy } from 'lodash-es'
import { useProvingGroundDropdownQuery } from 'model'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import {
  AsyncDropdown,
  AsyncDropdownProps,
  FormikAsyncDropdownFactory,
} from '../AsyncDropdown'

export type ProvingGroundDropdownProps = Omit<
  AsyncDropdownProps,
  'onResolveOptions'
> & {
  emptyOption?: boolean
}

export const ProvingGroundDropdown: React.FunctionComponent<
  ProvingGroundDropdownProps
> = ({ emptyOption = false, placeholders, ...props }) => {
  let resolve: any
  const resolveOptions: PromiseLike<IDropdownOption[]> = new Promise<
    IDropdownOption[]
  >((r, e) => {
    resolve = r
  })

  useProvingGroundDropdownQuery({
    onCompleted: (data) => {
      const options = [
        ...(emptyOption ? [{ key: '', text: '' }] : []),
        ...data!.provingGrounds.map((x) => ({
          key: x._id,
          text: `${x.title} (${x.abbr})`,
        })),
      ]
      resolve(sortBy(options, 'text'))
    },
  })

  return (
    <AsyncDropdown
      onResolveOptions={resolveOptions}
      placeholders={{
        loading: 'Daten werden geladen...',
      }}
      {...props}
    />
  )
}

export const ProvingGroundDropdownWithoutAbbr: React.FunctionComponent<
  ProvingGroundDropdownProps
> = ({ ...props }) => {
  let resolve: any
  const resolveOptions: PromiseLike<IDropdownOption[]> = new Promise<
    IDropdownOption[]
  >((r, e) => {
    resolve = r
  })

  useProvingGroundDropdownQuery({
    onCompleted: (data) => {
      const options: IDropdownOption[] = data!.provingGrounds.map((x) => ({
        key: x._id,
        text: `${x.title}`,
      }))
      resolve(sortBy(options, 'text'))
    },
  })

  return <AsyncDropdown onResolveOptions={resolveOptions} {...props} />
}

export const FormikProvingGroundDropdown = FormikAsyncDropdownFactory(
  ProvingGroundDropdown
)
